module.exports = __webpack_public_path__ + "img/BACK SUSTENTABLE-02.59c4f3d7.png";